module.exports = __webpack_public_path__ + "img/receive.51972e03.png";